import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    derivationErrorOpen: false,
    derivationError: '',
};

export const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setDerivationErrorOpen: (state, action) => {
            state.derivationErrorOpen = action.payload;
        },
        setDerivationError: (state, action) => {
            state.derivationError = action.payload;
        },
    },
});

export const { setDerivationErrorOpen, setDerivationError } = errorSlice.actions;

export default errorSlice.reducer;
